<template>
    <button
      v-if="!to"
      :class="$style.button" :disabled="disabled" @click="eventActive">
      <span>{{text}}</span>
    </button>
    <a target="_blank" :href="to" v-else :class="$style.button" :disabled="disabled">
      <span>{{text}}</span>
    </a>
</template>

<script>
export default {
  props: {
    text: {
      type: String,
      default: 'ОК',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    to: {
      type: String,
    },
  },
  name: 'Button',
  methods: {
    eventActive() {
      this.$emit('click')
    },
  },
}
</script>
<style lang="scss" module>
  @import './Button.sass';
</style>
